import React from 'react'
import AddAssetPart from '../PureComponent/AddAssetPart'
const RenderAddAssetPart = () => {
  return (
 <AddAssetPart/>
  )
}

export default RenderAddAssetPart